import React from 'react';
import { CheckCircle2, AlertTriangle, XCircle } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';

const STATUS_ICON = {
  ok: <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0" />,
  needs_review: <AlertTriangle className="w-5 h-5 text-amber-500 flex-shrink-0" />,
  error: <XCircle className="w-5 h-5 text-red-600 flex-shrink-0" />,
};

/**
 * Общий диалог итогов массовой загрузки — используется и для счетов, и для
 * платёжек. Страница сама приводит «сырые» результаты API к единому виду
 * {filename, status, primary, detail}, чтобы диалог не знал про разницу
 * между счетами и платежами.
 */
export default function UploadResultsDialog({ isOpen, onClose, title, summary, results }) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>

        {summary && (
          <div className="flex gap-4 text-sm">
            <span className="text-gray-600">Всего: <b>{summary.total}</b></span>
            <span className="text-green-700">Успешно: <b>{summary.ok}</b></span>
            <span className="text-amber-600">Требует проверки: <b>{summary.needs_review}</b></span>
            <span className="text-red-600">Ошибок: <b>{summary.errors}</b></span>
          </div>
        )}

        <div className="max-h-96 overflow-y-auto space-y-2">
          {(results || []).map((r, idx) => (
            <div
              key={idx}
              className="flex items-start gap-3 p-3 rounded-lg border border-gray-200 bg-gray-50"
              data-testid={`bulk-result-row-${idx}`}
            >
              {STATUS_ICON[r.status] || STATUS_ICON.error}
              <div className="min-w-0 flex-1">
                <p className="text-sm font-medium text-gray-900 truncate">{r.filename}</p>
                {r.primary && <p className="text-sm text-gray-700">{r.primary}</p>}
                {r.detail && <p className="text-xs text-gray-500 mt-0.5">{r.detail}</p>}
              </div>
            </div>
          ))}
        </div>

        <DialogFooter>
          <Button onClick={onClose} data-testid="close-bulk-results-btn">Закрыть</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
